var InFlight = InFlight || {};
InFlight.tableSorting = (function () {
  var getPrefix = function (id) {
    return id.split("$")[0];
  };

  var getWinIndex = function (id) {
    return id.split("$")[1].split("#")[0];
  };

  var getTriggeredColIndex = function (id) {
    return id.split('#')[1];
  };

  var _getSortTextId = function (id) {
    return getPrefix(id) + "$hnewpers$" + getWinIndex(id);
  };

  // sorting is controlled by a pipe delimited string of values linked to an id associated with each column (e.g. '0|0|1|0|0|0|0#4|0|1|1|1|53|0#5|0|1|1|3|74|0#7|0|1|2|4|121|0...')
	// the following works to flip the sorting direction(at index 3) and update counting digit (at index 4) on the selected column.
  var _updateSortText = function (srtText, trgElemId) {
    var trgColIdx = getTriggeredColIndex(trgElemId);
    var cols = srtText.split("#");
    var trgColElem = cols[trgColIdx].split("|"); 
    for (var i = 0; i < cols.length; i++) {
      elem = cols[i].split("|");
      if (elem.length < 5 || trgColIdx == i) {
        continue;
      }
      if (
        elem[4] > 0 &&
        (trgColElem[4] == 0 ||
          (trgColElem[4] > 0 && elem[4] <= trgColElem[4]))
      ) {
        elem[4]++;
      }
      cols[i] = elem.join("|");
    }
    trgColElem[4] = "1";
    var srtDirection = trgColElem[3];
    trgColElem[3] = srtDirection === "1" ? "2" : "1";
    cols[trgColIdx] = trgColElem.join("|");
    return cols.join("#");
  }

  var _getSortAction = function (id) {
    return getPrefix(id) + "$srt" + getTriggeredColIndex(id) + "$" + getWinIndex(id);
  };

  return {
    getSortTextId: _getSortTextId,
    getSortAction: _getSortAction,
    updateSortText: _updateSortText
  };
})();
